import { useAtomValue, useSetAtom } from "jotai";
import classnames from "classnames";
import { useEffect } from "react";
import pluralize from "pluralize";

import {
  subitemDrawerAtom,
  showSubitemDrawerAtom,
} from "../../../atoms/PageAtoms";
import AppSpinner from "../../../elements/AppSpinner";
import DisplayRecord from "../DisplayRecord";
import { IsMobileAtom } from "../../../App";
import Constants from "../../../utils/Constants";
import StrUtils from "../../../utils/StrUtils";

const SubitemRecord = ({
  tableView,
  parentRecord,
  type,
  field,
  existingValue,
  mode,
  displayMode,
  submitting,
  moduleAPIName,
  reusableViewReferenceFields,
}) => {
  const mobileScreen = useAtomValue(IsMobileAtom);
  const setSubitemDrawer = useSetAtom(subitemDrawerAtom);
  const setShowDrawer = useSetAtom(showSubitemDrawerAtom);
  const value = existingValue;
  const isSubitem = type === Constants.FIELDTYPES.SUBITEM;

  const getSubitemName = () => {
    if (value) {
      return Object.keys(value).length
        ? value?.[field?.SubitemRecordNameField] || "View Subitem"
        : `Add ${field?.Name}`;
    } else {
      return `Add ${field?.Name}`;
    }
  };

  const getMultiSubitemName = () => {
    if (Array.isArray(value) && value.length > 0) {
      return `${StrUtils.numberFormat(value.length)} ${pluralize(
        field?.Name,
        value?.length
      )}`;
    }

    return `No ${pluralize(field?.Name, 2)}`;
  };

  const handleOpenSubitemDrawer = () => {
    setShowDrawer(true);
    setSubitemDrawer({
      open: true,
      parentRecord,
      field,
      displayMode,
      moduleAPIName,
      reusableViewReferenceFields: reusableViewReferenceFields,
    });
  };

  useEffect(() => {
    setSubitemDrawer((prev) => {
      if (!prev?.parentRecord || !Object.keys(prev).length) return prev;
      if (prev?.parentRecord?._id !== parentRecord?._id) return prev;

      return { ...prev, parentRecord };
    });
  }, [parentRecord]);

  const displayName = isSubitem ? getSubitemName() : getMultiSubitemName();

  return (
    <>
      <DisplayRecord
        mode={mode}
        tableView={tableView}
        openModify={handleOpenSubitemDrawer}
        isSensitive={field?.Sensitive ?? false}
        displayComponent={(an, innerRef) => {
          return (
            <>
              {submitting ? (
                <AppSpinner size="sm" />
              ) : (
                <div ref={innerRef}>
                  <div
                    style={{ maxWidth: 340 }}
                    className={classnames(
                      "text-truncate",
                      { "pr-4": !mobileScreen },
                      { "pr-0": mobileScreen }
                    )}
                  >
                    {/* eslint-disable-next-line */}
                    <a
                      onClick={handleOpenSubitemDrawer}
                      className="link-primary cursor-pointer"
                    >
                      <i className="mdi mdi-file-tree mr-2"></i>
                      {displayName}
                    </a>
                  </div>
                </div>
              )}
            </>
          );
        }}
      />
    </>
  );
};

export default SubitemRecord;
